<template>
  <el-dialog title="提示" :visible.sync="dialogVisible" width="500px" :before-close="hide">
    <div class="text-center">
      <p>{{ content }}</p>
      <el-row>
        <el-col :span="12">
          <div class="flex-center">
            成功：<el-link type="success" :underline="false">{{ form.successQty }}</el-link
            ><span class="text">笔</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="flex-center">
            失败：<el-link type="danger" :underline="false">{{ form.failQty }}</el-link
            ><span class="text">笔</span>
          </div>
        </el-col>
        <el-col v-if="form.failRemark" :span="24" style="text-align:left;">
          <p>失败原因：</p>
          <div v-for="(text, index) in form.failRemark" :key="index">{{ text }}</div>
        </el-col>
      </el-row>
    </div>
    <span slot="footer" class="dialog-footer">
      <!-- <el-button @click="dialogVisible = false">{{ $t('cancelText') }}</el-button> -->
      <!-- <el-button type="primary" @click="dialogVisible = false">{{ $t('okText') }}</el-button> -->
    </span>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      form: {},
      content: null,
    };
  },
  methods: {
    show(info, content) {
      this.form = info;
      this.content = content;
      this.dialogVisible = true;
    },
    hide() {
      this.dialogVisible = false;
    },
  },
};
</script>
<style scoped lang="scss">
.el-dialog__body {
  padding: 15px 20px;
}
.el-link {
  font-size: 20px;
}
.el-link.el-link--success {
  color: $green;
}
.text {
  font-size: 20px;
}
</style>
